import { render, staticRenderFns } from "./informasi-barang-keluar.vue?vue&type=template&id=4c26484c&"
import script from "./informasi-barang-keluar.vue?vue&type=script&lang=js&"
export * from "./informasi-barang-keluar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports